export const TONE_RANK = { bad: 0, hot: 1, warn: 2, good: 3, neutral: 4 };
export const MAX_FINDINGS = 5;

export const sortFindings = list =>
  (Array.isArray(list) ? list : [])
    .map((f, i) => [f, i])
    .sort(
      ([a, ai], [b, bi]) =>
        (TONE_RANK[a.tone] ?? 9) - (TONE_RANK[b.tone] ?? 9) || ai - bi
    )
    .map(([f]) => f)
    .slice(0, MAX_FINDINGS);
